<template>
  <div class="autocomplete-field">
    <v-text-field
      flat
      solo
      required
      class="mt-2"
      v-model="query"
      :readonly="readonly"
      @input="$emit('input', query)"
      @change="$emit('input', query)"
      @keyup="onKeyupLocation($event)"
      @keydown.esc="selectLocation(-1)"
      :error-messages="inputError"
    ></v-text-field>

    <ul class="autocomplete-list" v-if="locations && showPredictions">
      <li
        class="autocomplete-list-item"
        v-for="(item, index) in locations"
        :key="item.id"
        :item="item"
        @click="selectLocation(index)"
        @keydown.esc="selectLocation(-1)"
      >
        <span class="autocomplete-list-item-icon"></span>
        <span class="autocomplete-list-item-label">{{ item.description }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import Api from '@/services/api'

export default {
  props: {
    value: String,
    inputError: Array,
    readonly: Boolean,
    all: Boolean
  },

  data() {
    return {
      query: '',
      locations: null,
      showPredictions: false
    }
  },

  watch: {
    value(value) {
      this.query = value

      if (!this.query) {
        this.$emit('select', null)
      }
    }
  },

  created() {
    this.query = this.value
  },

  methods: {
    onKeyupLocation(e) {
      if (this.query.length > 3) {
        this.showPredictions = true
        this.getPlaceLocation(this.query)
      } else {
        this.showPredictions = false
        this.resetPlaceLocation()
      }

      this.$emit('select', '')
    },

    selectLocation(index) {
      this.select(this.locations[index])
      this.resetPlaceLocation()
    },

    select(place) {
      this.query = place.description
      this.$emit('input', this.query)
      this.$emit('select', place.place_id)
    },

    async getPlaceLocation(input) {
      let url = `places?input=${input}`

      if (this.all === false) {
        url = `places?input=${input}&types=(cities)`
      }

      const { data } = await Api.get(url)
      this.locations = data.data
    },

    resetPlaceLocation() {
      this.locations = null
    }
  }
}
</script>

<style lang="scss" scoped>
.autocomplete-list {
  margin: 0;
  padding: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  list-style-type: none;
  border-radius: 6px;
  z-index: 99;
  position: absolute;
  background: #fff;
  overflow: hidden;
  text-align: left;
  top: 50px;
  width: 400px;
}

.autocomplete-list-item {
  padding: 8px 15px;
  list-style: none;
}
.autocomplete-list-item.selected,
.autocomplete-list-item:hover {
  cursor: pointer;
  background-color: #f8f9fa;
}

.autocomplete-field {
  position: relative;
}
</style>
